import { useQuery } from '@apollo/client'
import getEmailTrackingEventsByUserEmail from 'graphQL/customers/listEmailTrackingEventsByUserEmail'

export const useGetEmailTrackingEventsByUserEmail = ({ variables }) => {
  return useQuery(getEmailTrackingEventsByUserEmail, {
    variables
  })
}
